const PROPOSAL_MODELS = {
  'C interno e externo': {
    id: 'C-interno-externo',
    title: 'Modelo C Interno e Externo',
    type: 'C',
    model: "1. Modelagem 3D interno, conforme projeto e necessidades do cliente; 1.1 - Desenvolvimento e reformulação de layout interno; 1.2 - Criação de mobiliário em MDF/Metal; 1.3 - Paredes internas (conforme medidas/croqui recebidas pelo cliente); 1.4 - Decoração básica; 1.5 - Humanização; 1.6 - Iluminação;  1.7 - Aberturas internas; 1.8 - Cenografia;",
    modelempty: "2. Modelagem 3D externo, conforme projeto e necessidades do cliente; 2.1 - Paredes externas (conforme medidas/croqui recebidas pelo cliente); 2.2 - Terreno; 2.3 - Entorno básico; 2.4 - Muros; 2.5 - Pátio completo, com todos as áreas previstas no projeto arquitetônico e vídeos/fotos do local; 2.6 - Acessos; 2.7 - Paisagismo básico genérico; 2.8 - Entorno básico; 2.9 - Humanização; 2.10 - Cenografia, conforme referências do cliente;"
  },

  'C interno': {
    id: 'C-interno',
    title: 'Modelo C Interno',
    type: 'C',
    model: "1. Modelagem 3D interno, conforme projeto e necessidades do cliente; 1.1 - Desenvolvimento e reformulação de layout interno; 1.2 - Criação de mobiliário em MDF/Metal; 1.3 - Paredes internas (conforme medidas/croqui recebidas pelo cliente); 1.4 - Decoração básica; 1.5 - Humanização; 1.6 - Iluminação;  1.7 - Aberturas internas;",
    modelempty: null
  },

  'C externo': {
    id: 'C-externo',
    title: 'Modelo C Externo',
    type: 'C',
    model: null,
    modelempty: "1. Modelagem 3D externo, conforme projeto e necessidades do cliente; 1.1 - Paredes externas (conforme medidas/croqui recebidas pelo cliente); 1.2 - Terreno; 1.3 - Entorno básico; 1.4 - Muros; 1.5 - Pátio completo, com todos as áreas previstas no projeto arquitetônico e vídeos/fotos do local; 1.6 - Acessos; 1.7 - Paisagismo básico genérico; 1.8 - Entorno básico; 1.9 - Humanização; 1.10 - Cenografia, conforme referências do cliente;"
  },

  'A interno e externo': {
    id: 'A-interno-externo',
    title: 'Modelo A Interno e Externo',
    type: 'A',
    model: "1. Modelagem 3D interno, conforme projeto e necessidades do cliente; 1.1 - Mobiliário interno genérico, para representação de volumetrias e layout, conforme planta baixa (dwg ou pdf) recebida pelo cliente); 1.2 - Paredes internas conforme planta baixa (croqui, dwg ou pdf) recebida pelo cliente; 1.3 - Decoração básica; 1.4 - Humanização básica; 1.5 - Iluminação; 1.6 - Aberturas internas;",
    modelempty: "2. Modelagem 3D externo, conforme projeto e necessidades do cliente; 2.1 - Paredes externas conforme planta baixa (croqui, dwg ou pdf) recebida pelo cliente; 2.2 - Terreno; 2.3 - Muros; 2.4 - Pátio completo, com todos as áreas previstas no projeto arquitetônico; 2.5 - Acessos; 2.6 - Paisagismo básico genérico; 2.7 - Entorno básico; 2.8 - Humanização básica;"
  },

  'A interno': {
    id: 'A-interno',
    title: 'Modelo A Interno',
    type: 'A',
    model: "1. Modelagem 3D interno, conforme projeto e necessidades do cliente; 1.1 - Mobiliário interno genérico, para representação de volumetrias e layout, conforme planta baixa (dwg ou pdf) recebida pelo cliente); 1.2 - Paredes internas conforme planta baixa (croqui, dwg ou pdf) recebida pelo cliente; 1.3 - Decoração básica; 1.4 - Humanização básica; 1.5 - Iluminação; 1.6 - Aberturas internas;",
    modelempty: null
  },

  'A externo': {
    id: 'A-externo',
    title: 'Modelo A Externo',
    type: 'A',
    model: null,
    modelempty: "1. Modelagem 3D externo, conforme projeto e necessidades do cliente; 1.1 - Paredes externas conforme planta baixa (croqui, dwg ou pdf) recebida pelo cliente; 1.2 - Terreno; 1.3 - Muros; 1.4 - Pátio completo, com todos as áreas previstas no projeto arquitetônico; 1.5 - Acessos; 1.6 - Paisagismo básico genérico; 1.7 - Entorno básico; 1.8 - Humanização básica;"
  }
};

export default PROPOSAL_MODELS;
